<script setup lang="ts" async>

import ZoekActiviteiten from "@/views/ActivitySearch/ZoekActiviteiten.vue"
import WidgetHeader from './components/WidgetHeader.vue';
import WidgetDetails from './components/WidgetDetails.vue';
import WidgetBoeken from './components/WidgetBoeken.vue';
import WidgetColors from './components/WidgetColors.vue';
import { computed, onMounted, reactive, watch } from "vue";
import activiteitRepository, { Activiteit, ActiviteitItem, ActiviteitKenmerk, ActiviteitLesWithTrainers } from "@/repositories/activiteit.repository";
import activiteittypeRepository, { Activiteittype } from "@/repositories/activiteittype.repository";
import kenmerkRepository, { KenmerkenList, Kenmerk } from "@/repositories/kenmerk.repository";
import CmsDataProvider, { CMS_DATA_ID } from "@/providers/cms.provider";

declare let _platformId: number;

const platformId = _platformId;

const cmsData = CmsDataProvider.get<{
  successTitle?: string;
  successMessage?: string;
  errorTitle?: string;
  errorMessage?: string;
  successImage?: string;

  headerImage?: string;
  headerTitle?: string;
}>(CMS_DATA_ID.ACTIVITEITEN_WIDGET);


const state = reactive({
  hasLessen: true, // Needs implementation
  total: 0,
  activeItem: {} as Activiteit,
  isLoading: true,
  isBoeken: false,
  isDetails: false,
})

const changeBoekenState = (activiteit: Activiteit) => {
  //Implement getting boeken
  state.activeItem = activiteit;
  state.isBoeken = true;
  state.isDetails = false;
}

const changeDetailsState = (activiteit: Activiteit) => {
  //Implement getting details
  state.activeItem = activiteit;
  state.isDetails = true;
  state.isBoeken = false;
}

const showOverview = computed(() => {
  return state.isBoeken == false && state.isDetails == false;
})

const headerTitleWithFallback = computed(() => {
  return cmsData.headerTitle ? cmsData.headerTitle : 'Sportmatch widget';
   
})

const kenmerken = reactive<KenmerkenList>({
  specifiekAanbodList: [] as Kenmerk[],
  inclusiefList: [] as Kenmerk[],
  aanbodInclusiefList: [] as Kenmerk[],
  types: [] as Activiteittype[],
  inspanningList: [] as Kenmerk[],
  doelgroepList: [] as Kenmerk[],
  voordeelList: [] as Kenmerk[],
  tagList: [] as Kenmerk[],
  faciliteitenList: [] as Kenmerk[],
})

const goBack = () => {
  state.isDetails = false;
  state.isBoeken = false;
}


onMounted(async () => {
  kenmerkRepository.getKenmerkenByCategorie(30).then((data: Kenmerk[]) => {
    kenmerken.aanbodInclusiefList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(5).then((data: Kenmerk[]) => {
    kenmerken.doelgroepList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(19).then((data: Kenmerk[]) => {
    kenmerken.voordeelList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(20).then((data: Kenmerk[]) => {
    kenmerken.tagList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(2).then((data: Kenmerk[]) => {
    kenmerken.specifiekAanbodList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(21).then((data: Kenmerk[]) => {
    kenmerken.inclusiefList = data;
  });

  kenmerkRepository.getKenmerkenByCategorie(3).then((data: Kenmerk[]) => {
    kenmerken.inspanningList = data;
  });

  activiteittypeRepository.getActiviteitTypes().then((data) => {
    kenmerken.types = data
  })
})

watch(
  () => state.activeItem.SportmomentId,
  () => {

    activiteitRepository.getById(state.activeItem.SportmomentId, platformId).then((data: ActiviteitItem) => {
      if (data) {
        state.activeItem.Beschrijving = data.Beschrijving;
        state.activeItem.ExtraKostenBeschrijving = data.ExtraKostenBeschrijving;
      }
    })

    activiteitRepository.getSportactiviteitKenmerken(state.activeItem.SportmomentId).then((data: ActiviteitKenmerk[]) => {
      if (data) {
        state.activeItem.Leeftijden = data.filter(function (item) { return item.Categorie == 1; });
        state.activeItem.FysiekeInspanning = data.filter(function (item) { return item.Categorie == 3; });
        state.activeItem.Doelgroep = data.filter(function (item) { return item.Categorie == 5; });
        state.activeItem.Voordeel = data.filter(function (item) { return item.Categorie == 19; });
        state.activeItem.Tag = data.filter(function (item) { return item.Categorie == 20; });
        state.activeItem.SpecifiekAanbod = data.filter(function (item) { return item.Categorie == 2; });
        state.activeItem.Inclusief = data.filter(function (item) { return item.Categorie == 21; });
        state.activeItem.AanbodInclusief = data.filter(function (item) { return item.Categorie == 30; });
      }
    })

    if (state.activeItem.Lessen?.length > 0) {
      activiteitRepository.getSportactiviteitLessen(state.activeItem.SportmomentId).then((data: ActiviteitLesWithTrainers[]) => {
        state.activeItem.Lessen = data;
      });
    }
  }
)

// iframe events
const closeWidget = () => {
  sendMessage('sportmatch-widget-close')
}

const sendMessage = (message: string) => {
  window.top?.postMessage(message, '*')
}

</script>

<template>
  <WidgetColors />
  <div class="sportmatch-widget-search">
    <div class="sportmatch-widget-panel">
      <WidgetHeader :title="headerTitleWithFallback" :image="cmsData.headerImage" @close="closeWidget" @go-back="goBack" :is-overview="showOverview">
      </WidgetHeader>
      <section class="sportmatch-widget-panel-content">
        <ZoekActiviteiten v-if="showOverview" :is-widget="true">
          <template #actions="ctx">
                  <button class="btn btn-sm btn-sport-in-light" :aria-label="'Meer informatie over ' + ctx.entity?.entity.Naam"
                          @click="changeDetailsState(ctx.entity?.entity)">
                      Meer info
                  </button>
                  <button class="btn btn-sm btn-outline-primary" @click="changeBoekenState(ctx.entity?.entity)"
                          :class="(!ctx.entity?.isRegistrationStarted || ctx.entity?.isRegistrationEnded || ctx.entity?.availableSpots <= 0) && 'disabled'"
                          :disabled="!ctx.entity?.isRegistrationStarted || ctx.entity?.isRegistrationEnded"
                          :aria-label="ctx.entity?.entity.Naam + ' boeken'">
                      Boeken
                  </button>
          </template>
        </ZoekActiviteiten>

        <WidgetDetails @open-boeken="changeBoekenState($event)" v-if="state.isDetails" :activiteit="state.activeItem"
          :kenmerken="kenmerken"></WidgetDetails>
        <WidgetBoeken v-if="state.isBoeken" :activiteit="state.activeItem" :platform="platformId" :cms-data="cmsData">
        </WidgetBoeken>
      </section>
    </div>
  </div>
</template>